import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Images, CalendarDays, Flame, Settings, ExternalLink } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './dashboard.css';

const ATALHOS = [
  { to: '/admin/documentos',    label: 'Documentos',     icone: FileText,     desc: 'Gerenciar atas, certidões e documentos',     cor: '#1e3a6e' },
  { to: '/admin/galeria',       label: 'Galeria',        icone: Images,       desc: 'Fotos de eventos, festejo e capa do site',    cor: '#d4a20a' },
  { to: '/admin/eventos',       label: 'Eventos',        icone: CalendarDays, desc: 'Publicar e gerenciar eventos culturais',       cor: '#0369a1' },
  { to: '/admin/festejo',       label: 'Festejo Junino', icone: Flame,        desc: 'Galeria e conteúdo do festejo junino',         cor: '#ea580c' },
  { to: '/admin/configuracoes', label: 'Configurações',  icone: Settings,     desc: 'Capa do site, logo e outras configurações',    cor: '#16a34a' },
];

export default function DashboardPage() {
  const { usuario } = useAuth();

  return (
    <div className="dashboard">
      {/* Boas-vindas */}
      <div className="dash-header">
        <div>
          <h1 className="dash-titulo">Painel Administrativo</h1>
          <p className="dash-sub">
            Bem-vindo, <strong>{usuario?.email}</strong>. Gerencie o conteúdo do site da LICMAB.
          </p>
        </div>
        <Link to="/" target="_blank" className="btn btn-fantasma btn-sm">
          <ExternalLink size={14} /> Ver site público
        </Link>
      </div>

      {/* Cards de acesso rápido */}
      <div className="dash-grid">
        {ATALHOS.map(item => {
          const Icone = item.icone;
          return (
            <Link key={item.to} to={item.to} className="dash-card">
              <div className="dash-card-icone" style={{ background: item.cor }}>
                <Icone size={24} color="white" />
              </div>
              <div className="dash-card-info">
                <h3>{item.label}</h3>
                <p>{item.desc}</p>
              </div>
              <span className="dash-card-seta">→</span>
            </Link>
          );
        })}
      </div>

      {/* Info institucional */}
      <div className="dash-info">
        <div className="dash-info-card">
          <h3>LICMAB — Liga Cultural de Marabá</h3>
          <div className="dash-info-grid">
            <div>
              <span className="dash-info-label">CNPJ</span>
              <span className="dash-info-valor">24.603.962/0001-01</span>
            </div>
            <div>
              <span className="dash-info-label">Fundação</span>
              <span className="dash-info-valor">15/10/2015</span>
            </div>
            <div>
              <span className="dash-info-label">Sede</span>
              <span className="dash-info-valor">Nova Marabá, Pará</span>
            </div>
            <div>
              <span className="dash-info-label">Status</span>
              <span className="dash-info-valor" style={{ color: 'var(--verde)' }}>● Ativo</span>
            </div>
          </div>
        </div>

        <div className="dash-orientacoes">
          <h3>Como usar o painel</h3>
          <ul>
            <li><strong>Documentos:</strong> publique atas, balancetes, certidões e outros documentos da transparência</li>
            <li><strong>Galeria:</strong> adicione fotos para a página de Eventos e Festejo Junino</li>
            <li><strong>Configurações:</strong> troque a imagem de capa do site e o logo da LICMAB</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
